// extracted by mini-css-extract-plugin
export var actionButton = "_pt-0";
export var actionMenuContainer = "_pt-i";
export var bubble = "_pt-2";
export var bubbleActionMenu = "_pt-j";
export var bubbleContext = "_pt-6";
export var bubbleItems = "_pt-7";
export var customer = "_pt-3";
export var divider = "_pt-8";
export var fileList = "_pt-9";
export var hiddenComment = "_pt-o";
export var infoAbove = "_pt-a";
export var internal = "_pt-4";
export var lightActionButton = "_pt-1";
export var link = "_pt-b";
export var merchant = "_pt-5";
export var message = "_pt-c";
export var profilePicture = "_pt-e";
export var quillToolbarContainer = "_pt-f";
export var senderDate = "_pt-g";
export var senderDateCustomer = "_pt-h";
export var senderName = "_pt-d";
export var time = "_pt-k";
export var uploadedImage = "_pt-l";
export var username = "_pt-m";
export var xsmall = "_pt-n";